import { AmenityModel } from "@/Pages/Admin/Modules/Models/Hotel/AmenityModel";

export class RoomAmenityModel {
         public id: number;
         public hotel_id: number;
         public room_id: number;
         public title: string;
         public amenity_id: number;
         public amenity: AmenityModel = new AmenityModel({});

         constructor(obj: any) {
           this.id = obj.id ? obj.id : 0;
           this.hotel_id = obj.hotel_id ? obj.hotel_id : "";
           this.room_id = obj.room_id ? obj.room_id : "";
           this.amenity_id = obj.amenity_id ? obj.amenity_id : "";
           this.title = obj.title ? obj.title : "";
           this.amenity = obj.amenity ? obj.amenity : new AmenityModel({});
         }
       }
